module.exports = __webpack_public_path__ + "media/home_background.6bb4a1c4.mp4";